import React, { useState } from "react";
import { X, Plus } from "@phosphor-icons/react";
import { Field } from "@/components/editor/Field";

const SUGGESTED = ["AI", "Smartphones", "Audio", "Auto", "Wearable", "Laptops", "Gaming", "Apps", "Cameras", "Smart Home"];
const MAX = 5;
const norm = (t) => t.trim().toLowerCase();

export const TagsField = ({ value, onChange }) => {
    const [draft, setDraft] = useState("");
    const has = (t) => value.some(v => norm(v) === norm(t));
    const full = value.length >= MAX;

    const add = (raw) => {
        const t = raw.replace(/\s+/g, " ").trim().slice(0, 30);
        if (!/[a-zA-Z0-9]/.test(t) || has(t) || full) { setDraft(""); return; }
        onChange([...value, t]);
        setDraft("");
    };
    const remove = (t) => onChange(value.filter(v => v !== t));
    const onKey = (e) => {
        if (e.key === "Enter" || e.key === ",") { e.preventDefault(); add(draft); }
        else if (e.key === "Backspace" && !draft && value.length) remove(value[value.length - 1]);
    };

    return (
        <Field label={`Tags (${value.length}/${MAX})`}>
            <div className="tz-input flex flex-wrap items-center gap-2 min-h-[52px]" data-testid="editor-tags">
                {value.map(t => (
                    <span key={t} className="inline-flex items-center gap-1.5 bg-[#FFD000] text-black font-mono text-[11px] font-bold uppercase tracking-[0.15em] pl-2.5 pr-1.5 py-1" data-testid={`editor-tag-${norm(t).replace(/\s+/g, "-")}`}>
                        {t}
                        <button type="button" onClick={() => remove(t)} aria-label={`Remove ${t}`} className="hover:bg-black/15 p-0.5" data-testid={`editor-tag-remove-${norm(t).replace(/\s+/g, "-")}`}>
                            <X size={12} weight="bold" />
                        </button>
                    </span>
                ))}
                <input
                    value={draft}
                    onChange={(e) => setDraft(e.target.value)}
                    onKeyDown={onKey}
                    onBlur={() => add(draft)}
                    disabled={full}
                    maxLength={30}
                    placeholder={full ? "Max 5 tags" : "Type a tag and press Enter..."}
                    className="flex-1 min-w-[160px] bg-transparent outline-none text-white placeholder:text-zinc-600"
                    data-testid="editor-tag-input"
                />
            </div>
            <div className="mt-3 flex flex-wrap gap-2">
                {SUGGESTED.filter(s => !has(s)).map(s => (
                    <button key={s} type="button" disabled={full} onClick={() => add(s)}
                            data-testid={`editor-tag-suggest-${norm(s).replace(/\s+/g, "-")}`}
                            className="inline-flex items-center gap-1 border border-zinc-700 text-zinc-300 font-mono text-[11px] uppercase tracking-[0.15em] px-2.5 py-1 hover:border-[#FFD000] hover:text-[#FFD000] transition-colors disabled:opacity-40 disabled:pointer-events-none">
                        <Plus size={10} weight="bold" /> {s}
                    </button>
                ))}
            </div>
        </Field>
    );
};
